import { render } from "./SelectValidityType.vue?vue&type=template&id=5bf6e5c4&ts=true"
import script from "./SelectValidityType.vue?vue&type=script&lang=ts"
export * from "./SelectValidityType.vue?vue&type=script&lang=ts"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__